export const loginSelector = ({ user }) => user.login;

export const userDataSelector = ({ user }) => user;

export const canMakeWithdrawSelector = ({ user }) => user.wallet.can_make_withdraw;

export const userIdSelector = ({ user }) => user.id;

export const userSelector = ({ user }) => user;
